import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { ReportMessageSettingsAction } from '../../../domains/reportMessage/settingsActions.types';

import { NetworkReportMessageSettings } from './types';

export type NetworkReportMessageSettingsAction = ReportMessageSettingsAction;

const initialState: NetworkReportMessageSettings = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<NetworkReportMessageSettings, NetworkReportMessageSettingsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'MESSAGE.LOAD_REPORT_SETTINGS_PENDING':
      return setPending();
    case 'MESSAGE.LOAD_REPORT_SETTINGS_FULFILLED':
      return setFulfilled(action.payload);
    case 'MESSAGE.LOAD_REPORT_SETTINGS_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
